import { __decorate } from "tslib";
import { SerializableObject } from '@openhps/core';
import { ldp } from '../../terms';
import { SerializableThing } from '@openhps/rdf';
let Container = class Container extends SerializableThing {
};
Container = __decorate([
    SerializableObject({
        rdf: {
            type: ldp.Container,
        },
    })
], Container);
export { Container };
//# sourceMappingURL=Container.js.map